<template>
  <div class="flow-container">
    <div class="header">
      <div class="title">交易流水查询</div>
      <p class="red-notice in-header">注意：因系统升级，此页面缺失部分特殊场景订单数据，如需查询订单明细数据，请使用【实时交易】页面进行查询或导出；如需导出汇总报表，请移步到【对账单导出】页面进行导出。</p>
    </div>
    <div class="search-from">
      <el-form inline class="inline-form" :model="flowForm" label-width="80px" label-position="left">
        <div>
          <el-form-item label="时间">
            <cumstom-date-time-range :type="0" @change="changeDateTimeRange" @typeChange="search"/>
          </el-form-item>
        </div>
        <div v-if="shopType">
          <el-form-item label="门店">
            <!-- <el-select
              v-model="flowForm.merchantId"
              placeholder="请选择"
              style="width: 310px;"
              @change="fetchCashierList(flowForm.merchantId)"
              size="small">
              <el-option value="all" label="所有门店"/>
              <el-option v-for="i in shopList" :key="i.merchantId" :label="i.merchantName" :value="i.merchantId"/>
            </el-select> -->
            <CommonSelect
              v-model="flowForm.merchantId"
              :options="shopList"
              :needPaging="true"
              :pageLoading="shopPageInfo.loading"
              @change="fetchCashierList(flowForm.merchantId)"
              @loadmore="queryShopList"
            />
          </el-form-item>
        </div>
        <div>
          <el-form-item label="收银点">
            <custom-select
              :isSelect="unselect"
              v-model="flowForm.cashierAreaList"
              :list="cashierList"
              type="1"
              @valueChange="handleCustomSelectChange"/>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="交易渠道" class="middle-item">
            <el-select
              v-model="flowForm.transType"
              placeholder="请选择"
              @change="changeChannel"
              style="width: 100px;margin-right: 16px;"
              size="small">
              <el-option label="扫码" value="0"/>
              <el-option label="刷卡" value="1"/>
            </el-select>
            <el-select v-model="flowForm.payType" multiple placeholder="请选择" style="width: 420px;" size="small">
              <template v-if="flowForm.transType === '1'">
                <el-option label="刷卡" value="0"/>
              </template>
              <template v-else>
                <el-option label="微信" value="0"/>
                <el-option label="支付宝" value="1"/>
                <el-option label="银联二维码" value="2"/>
                <el-option label="数字人民币" value="9"/>
                <el-option label="抖音支付" value="15"/>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="交易单号" class="middle-item">
            <el-input v-model="flowForm.leshuaOrderId" placeholder="请输入交易单号" style="width: 310px;" size="small"/>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="交易金额" class="trans-amount" size="small">
            <el-input v-model="flowForm.minTransAmount" placeholder="最小交易金额" style="width: 147px;" @change="minAmount"/>
            <span class="line"/>
            <el-input v-model="flowForm.maxTransAmount" placeholder="最大交易金额" style="width: 147px;" @change="maxAmount"/>
          </el-form-item>
          <el-form-item v-if="is25" label="结算类型" class="trans-amount" size="small">
            <el-select v-model="flowForm.settleType">
              <el-option label="全部" value=''/>
              <el-option label="D+1" :value='0'/>
              <el-option label="D+0" :value='1'/>
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型" class="trans-amount" size="small">
            <el-select :disabled="unselect" clearable v-model="flowForm.transToolTypeNo">
              <el-option label="乐刷SN" :value='2'/>
              <el-option label="乐刷ID" :value='3'/>
              <el-option label="设备SN" :value='1'/>
              <el-option label="码牌SN" :value='4'/>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="设备编号" class="middle-item">
            <el-select
              :disabled="unselect"
              v-model="flowForm.transToolNum"
              filterable
              placeholder="请选择设备编号"
              clearable
              size="small">
              <el-option v-for="item in deviceNumber" :key="item" :label="item" :value="item"/>
            </el-select>
          </el-form-item>
          <el-form-item label="交易状态">
            <el-select v-model="flowForm.transStatus" placeholder="请选择" style="width: 310px;" size="small">
              <template v-if="flowForm.transType === '0' && flowForm.cashierAreaList.length === 0">
                <el-option label="交易初始" value="0"/>
                <el-option label="支付成功" value="1"/>
                <el-option label="支付失败" value="2"/>
                <el-option label="退款成功" value="3"/>
                <el-option label="退款失败" value="4"/>
                <el-option label="退款中" value="5"/>
                <el-option label="撤销成功" value="6"/>
              </template>
              <template v-if="flowForm.transType === '1' && flowForm.cashierAreaList.length === 0 ">
                <el-option label="交易初始" value="0"/>
                <el-option label="支付成功" value="5"/>
                <el-option label="支付失败" value="11"/>
                <el-option label="冲正成功" value="53"/>
                <el-option label="退款成功" value="3"/>
                <el-option label="退款中" value="31"/>
                <el-option label="退款失败" value="32"/>
                <!-- <template v-if="flowForm.payType.includes('1')"> -->
                <el-option label="预授权成功" value="40"/>
                <el-option label="预授权失败" value="41"/>
                <el-option label="预授权完成成功" value="44"/>
                <el-option label="预授权完成失败" value="45"/>
                <el-option label="预授权完成撤销成功" value="48"/>
                <el-option label="预授权完成撤销失败" value="49"/>
                <el-option label="预授权撤销成功" value="42"/>
                <el-option label="预授权撤销失败" value="43"/>
                <!-- </template> -->
              </template>
              <!-- 当选择了收银点选项,只保留支付成功和退款成功 -->
              <template v-else-if="flowForm.transType === '0' && flowForm.cashierAreaList.length !== 0">
                <el-option label="支付成功" value="1"/>
                <el-option label="退款成功" value="3"/>
              </template>
              <template v-else-if="flowForm.transType === '1' && flowForm.cashierAreaList.length !== 0">
                <el-option label="支付成功" value="5"/>
                <el-option label="退款成功" value="3"/>
              </template>
            </el-select>
          </el-form-item>
          <span class="btn-box">
            <el-button
              type="primary"
              @click="search"
              class="bs-btn"
              :disabled="btnCanNotClick"
              :class="{ 'save-btn-active': btnCanNotClick }"
            >查询</el-button>
            <el-button
              type="primary"
              class="bs-btn"
              v-loading="exportLoading"
              :class="{ 'save-btn-active': btnCanNotClick }"
              @click="exportTable(vm)"
              :disabled="btnCanNotClick">导出</el-button>
            <el-button
              type="primary"
              class="bs-btn"
              v-loading="exportLoading"
              :class="{ 'save-btn-active': btnCanNotClick }"
              @click="exportTable(vm, 2)"
              :disabled="btnCanNotClick"
            >导出全部交易渠道</el-button>
          </span>
        </div>
      </el-form>
    </div>
    <div class="table-content">
      <div class="table-content-item">
        <el-table :data="tableData" style="width: 100%;" border v-loading="loadingTable">
          <el-table-column prop="transTime" label="交易时间" align="center"/>
          <el-table-column prop="leshuaOrderId" label="交易单号" align="center"/>
          <el-table-column v-if="is25" prop="settleType" label="结算类型" align="center">
            <template slot-scope="{row}">{{ row.settleType == 1 ? 'D+0' : 'D+1' }}</template>
          </el-table-column>
          <el-table-column prop="shopTypeValue" label="交易门店" align="center"/>
          <el-table-column prop="merchantName" label="门店名称" align="center"/>
          <el-table-column prop="cashierAreaName" label="收银点" align="center" v-if="showCashierColumn"/>
          <el-table-column prop="transAmount" label="交易金额" align="center">
            <template slot-scope="{row}">{{ row.transAmount / 100 }}</template>
          </el-table-column>
          <el-table-column prop="payTypeValue" label="交易渠道" align="center"/>
          <el-table-column prop="transStatusValue" label="交易状态" align="center"/>
          <el-table-column label="详情" align="center">
            <template slot-scope="{row}">
              <span class="view-detail" @click="viewFlowDetail(row,false)">查看</span>
              <!--<span class="view-detail view-refund" v-if="ifRefundShow(row)" @click="viewFlowDetail(row,true)">退款</span>-->
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            :page-size="page.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"/>
        </el-col>
      </div>
    </div>
    <div class="view-detail">
      <el-dialog title="交易详情" :visible.sync="dialogViewDetial" width="30%">
        <div class="content">
          <div class="one-part">
            <div class="item-info">
              <span class="title">交易单号</span>
              <span class="text">{{ transDetail.leshuaOrderId }}</span>
            </div>
            <div class="item-info">
              <span class="title">{{ transDetail.payTypeValue }}单号</span>
              <span class="text">{{ transDetail.channelTransactionId }}</span>
            </div>
            <div class="item-info">
              <span class="title">银行单号</span>
              <span class="text">{{ transDetail.channelOrderId }}</span>
            </div>
          </div>
          <div class="one-part">
            <div class="item-info">
              <span class="title">商户编号</span>
              <span class="text">{{ transDetail.merchantId }}</span>
            </div>
            <div class="item-info">
              <span class="title">门店名称</span>
              <span class="text">{{ transDetail.merchantName }}</span>
            </div>
            <div class="item-info">
              <span class="title">门店类型</span>
              <span class="text">{{ transDetail.shopTypeValue }}</span>
            </div>
          </div>
          <div class="one-part">
            <div class="item-info">
              <span class="title">交易时间</span>
              <span class="text">{{ transDetail.transTime }}</span>
            </div>
            <div class="item-info">
              <span class="title">交易状态</span>
              <span class="text">{{ transDetail.transStatusValue }}</span>
            </div>
            <div class="item-info">
              <span class="title">交易渠道</span>
              <span class="text">{{ transDetail.payTypeValue }}</span>
            </div>
            <div class="item-info">
              <span class="title">收款设备</span>
              <span class="text">{{ transDetail.transToolCustomerName }}</span>
            </div>
            <div class="item-info">
              <span class="title">设备编号</span>
              <span class="text">{{ transDetail.transToolNum }}</span>
            </div>
            <div class="item-info">
              <span class="title">交易金额</span>
              <span class="text">{{ transDetail.transAmount / 100 }}</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="bs-btn" type="primary" @click="dialogViewDetial = false">知道了</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="refundTitle" width="30%" :visible.sync="refundDialogViewDetial">
        <div v-if="refundStep === 1">
          <div class="content">
            <div class="one-part">
              <div class="item-info">
                <span class="title">交易单号</span>
                <span class="text">{{ transDetail.leshuaOrderId }}</span>
              </div>
              <div class="item-info">
                <span class="title">交易门店</span>
                <span class="text">{{ transDetail.merchantName }}</span>
              </div>
              <div class="item-info">
                <span class="title">交易渠道</span>
                <span class="text">{{ transDetail.payTypeValue }}</span>
              </div>
              <div class="item-info">
                <span class="title">订单金额</span>
                <span class="text">{{ transDetail.transAmount / 100 }}</span>
              </div>
            </div>
            <div class="one-part">
              <div class="item-info">
                <span class="title title-input">退款金额</span>
                <span class="text title-input">
                  <el-input-number
                    :max="availableRefund / 100"
                    :precision="2"
                    :min="0"
                    controls-position="right"
                    v-model="refundForm.refund_amount"/>
                  <span>{{ '最多可退' + availableRefund / 100 }}</span>
                  <el-button type="text" @click="()=>{refundForm.refund_amount = availableRefund / 100}">
                    全部退款
                  </el-button>
                </span>
              </div>
              <div class="item-info">
                <span class="title">店长账号</span><span class="text">{{ userName }}</span>
              </div>
              <div class="item-info">
                <span class="title title-input">管理密码</span>
                <span class="text title-input">
                  <el-input show-password v-model="refundForm.businessVerifyCode"/>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="refundStep === 2" class="refund-step-two">
          <img src="../../assets/images/flow/ok.png" alt="">
          <span>退款成功</span>
          <div>{{ '退款金额：￥' + refundForm.refund_amount }}</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            class="refund-btn-grey"
            v-if="refundStep === 1"
            @click="refundDialogViewDetial = false"
          >取消</el-button>
          <el-button type="primary" class="bs-btn" v-if="refundStep === 1" @click="refundConfirm">确认</el-button>
          <el-button
            type="primary"
            class="bs-btn"
            v-if="refundStep === 2"
            @click="refundDialogViewDetial = false"
          >{{ `知道了(${this.refundTimeoutNum})` }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import CumstomDateTimeRange from "@/components/CustomDateTimeRange/index.vue";
import CustomSelect from "@/components/CustomSelect/index.vue";
import CommonSelect from "@/components/CommonSelect.vue";
import { queryShopList } from "@/api/merchant-info";
import { v160Mixins } from "@/mixins/mixinsv160";
import {
  listTransDetail, listAllTransToolByMerchantId, fetchCashiers, getOrderAvailableAmount, checkBusinessVerifyCode,
} from "@/api/flow";
import {
  formatDatehour, debounce, downLoadFileByForm, formatDate,
} from "@/utils/index";
import { host } from "@/global-config";

export default {
  name: "flow",
  components: {
    CumstomDateTimeRange,
    CustomSelect,
    CommonSelect,
  },
  mixins: [v160Mixins],
  data() {
    return {
      // 新增的收银点列表
      cashierList: [],
      transDetail: {
        leshuaOrderId: "",
        channelTransactionId: "",
        channelOrderId: "",
        merchantId: "",
        merchantName: "",
        shopTypeValue: "",
        transTime: "",
        transStatusValue: "",
        payTypeValue: "",
        transToolName: "",
        transQrcodeNum: "",
        transAmount: "",
      },
      showCashierColumn: false,
      flowForm: {
        transStartTime: "",
        transEndTime: "",
        transType: "0",
        settleType: "",
        transStatus: "1",
        minTransAmount: "",
        maxTransAmount: "",
        transToolNum: "",
        leshuaOrderId: "",
        merchantId: "",
        transToolTypeNo: "",
        payType: ["0", "1", "2", "9", "15"],
        cashierAreaList: [],
      },
      refundForm: {
        businessVerifyCode: '',
        refund_amount: '',
      },
      dialogViewDetial: false,
      refundDialogViewDetial: false,
      loadingTable: false,
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      tableData: [],
      shopList: [{ label: '所有门店', value: 'all' }],
      shopPageInfo: {
        loading: false,
        pageNo: 1,
        pageSize: 30,
        finished: false,
      },
      deviceNumber: [],
      exportLoading: false,
      vm: this,
      btnCanNotClick: false,
      shopType: 1,
      availableRefund: 0,
      refundStep: 1,
      refundTitle: '订单退款',
      refundTimeout: '',
      refundInter: '',
      refundTimeoutNum: '',
      unselect: false, // 不可选
    };
  },
  watch: {
    "flowForm.merchantId": {
      deep: true,
      handler(newVal) {
        this.unselect = newVal === 'all';
        if (newVal === 'all') {
          this.flowForm.transToolTypeNo = '';
          this.flowForm.transToolNum = '';
          this.flowForm.cashierAreaList = [];
        }
        if (this.flowForm.transToolTypeNo) {
          this.getDeviceInfo(newVal, this.flowForm.transToolTypeNo);
        }
      },
    },
    "flowForm.transToolTypeNo": {
      deep: true,
      handler(newVal) {
        if (this.flowForm.merchantId) {
          this.getDeviceInfo(this.flowForm.merchantId, newVal);
        }
      },
    },
    "transDetail.leshuaOrderId": {
      deep: true,
      handler(newVal) {
        getOrderAvailableAmount(newVal).then(({ data }) => {
          this.availableRefund = data.data;
        });
      },
    },
    refundDialogViewDetial(newVal) {
      if (!newVal) {
        this.refundStep = 1;
        this.refundTitle = '订单退款';
        this.refundForm = {
          businessVerifyCode: '',
          refund_amount: '',
        };
        clearInterval(this.refundInter);
        clearTimeout(this.refundTimeout);
      }
    },
  },
  computed: {
    loginInfo() {
      const str = localStorage.getItem('LOGIN_INFO');
      return JSON.parse(str);
    },
    userName() {
      return this.loginInfo.userName;
    },
  },
  mounted() {
    this.queryShopList();
    if (this.loginInfo) this.shopType = this.loginInfo.shopType;
  },
  destroyed() {
    clearInterval(this.refundInter);
    clearTimeout(this.refundTimeout);
  },
  methods: {
    ifRefundShow(row) {
      const tim = row.transTime;
      // eslint-disable-next-line new-cap
      const asd = new dayjs();
      const nowTime = asd.format('M');
      const upTime = dayjs(tim).format('M');
      const overtime = !(nowTime - upTime < 3 && nowTime - upTime > -3);
      // 增加判断扫码订餐的订单，且渠道为支付宝或者微信，不能退款
      return this.loginInfo.userRole !== 0 && this.flowForm.transType === '0' && !overtime && !(row.sourceType === '45' && [0, 1].includes(row.payType));
    },
    // 根据商户号查询更新收银点
    fetchCashierList(id) {
      this.flowForm.cashierAreaList = [];
      fetchCashiers([id]).then((res) => {
        if (res.data.error_code === 0) {
          if (res.data.data.list.length === 0) {
            this.showCashierColumn = false;
          } else {
            this.showCashierColumn = true;
            res.data.data.list.unshift({ cashierAreaNo: "@", cashierAreaName: "全部收银点" });
          }
          this.cashierList = res.data.data.list;
        }
      });
    },
    // 交易渠道
    changeChannel(val) {
      if (val === "0") {
        this.flowForm.payType = ["0", "1", "2", "9", "15"];
        this.flowForm.transStatus = "1";
      } else {
        this.flowForm.payType = ["0"];
        this.flowForm.transStatus = "5";
      }
    },
    minAmount(val) {
      //  必须正数，可以为小数，
      const reDigital = /^\d+(?=\.{0,1}\d+$|$)/;
      const nowVal = parseFloat(val, 10);
      const max = parseFloat(this.flowForm.maxTransAmount, 10);
      if (!reDigital.test(val) && val !== "") {
        this.$message.error("请输入正确的交易金额");
      } else if (val && nowVal > max && this.flowForm.maxTransAmount !== "") {
        this.$message.error("最小交易金额不能大于最大交易金额");
      }
    },
    maxAmount(val) {
      const reDigital = /^\d+(?=\.{0,1}\d+$|$)/;
      const nowVal = parseFloat(val, 10);
      const min = parseFloat(this.flowForm.minTransAmount, 10);
      if (!reDigital.test(val) && val !== "") {
        this.$message.error("请输入正确的交易金额");
      } else if (val && nowVal < min && this.flowForm.minTransAmount !== "") {
        this.$message.error("最大交易金额不能小于最小交易金额");
      }
    },
    changeDateTimeRange(dateTimeRange) {
      if (!dateTimeRange.length) {
        this.flowForm.transStartTime = "";
        this.flowForm.transEndTime = "";
        return;
      }
      const date = new Date().getTime();
      // 日期是否包含今天
      if (formatDate(date) === formatDate(dateTimeRange[1])) {
        this.flowForm.transStartTime = formatDatehour(dateTimeRange[0]);
        this.flowForm.transEndTime = formatDatehour(dateTimeRange[1]);
      } else {
        this.flowForm.transStartTime = formatDatehour(dateTimeRange[0]);
        this.flowForm.transEndTime = formatDatehour(dateTimeRange[1]);
      }
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryData();
    },
    search() {
      this.page.pageNo = 1;
      const reDigital = /^\d+(?=\.{0,1}\d+$|$)/;
      if (this.flowForm.minTransAmount !== "" && !reDigital.test(this.flowForm.minTransAmount)) {
        this.$message.error("请输入正确的交易金额");
      } else if (this.flowForm.maxTransAmount !== "" && !reDigital.test(this.flowForm.maxTransAmount)) {
        this.$message.error("请输入正确的交易金额");
      } else if (this.flowForm.maxTransAmount !== "" && this.flowForm.minTransAmount !== "" && parseFloat(this.flowForm.maxTransAmount, 10) < parseFloat(this.flowForm.minTransAmount, 10)) {
        this.$message.error("最大交易金额不能小于最小交易金额");
      } else {
        this.queryData();
      }
    },
    // 导出
    exportTable: debounce(
      (vm, num) => {
        const reDigital = /^\d+(?=\.{0,1}\d+$|$)/;
        if (vm.flowForm.minTransAmount !== "" && !reDigital.test(vm.flowForm.minTransAmount)) {
          vm.$message.error("请输入正确的交易金额");
        } else if (vm.flowForm.maxTransAmount !== "" && !reDigital.test(vm.flowForm.maxTransAmount)) {
          vm.$message.error("请输入正确的交易金额");
        } else if (vm.flowForm.maxTransAmount !== "" && vm.flowForm.minTransAmount !== "" && parseFloat(vm.flowForm.maxTransAmount, 10) < parseFloat(vm.flowForm.minTransAmount, 10)) {
          vm.$message.error("最大交易金额不能小于最小交易金额");
        } else {
          vm.exportList(num);
        }
      },
      200,
      true,
    ),
    exportList(num) {
      const { userName, sessionId } = this.loginInfo;
      const url = `${host}/trans/exportTransListV2?userName=${userName}&sessionId=${sessionId}`;
      const param = Object.assign({}, this.flowForm);
      if (param.cashierAreaList[0] === "@") {
        param.cashierAreaList = [];
        this.cashierList.forEach((v) => {
          if (v.cashierAreaNo !== "@") {
            param.cashierAreaList.push(v.cashierAreaNo);
          }
        });
      }
      if (num) {
        param.transType = num;
      }
      downLoadFileByForm(url, param);
      this.exportLoading = false;
    },
    // 获取门店列表
    queryShopList() {
      const { pageNo, finished, pageSize } = this.shopPageInfo;
      if (finished) return false;
      const params = {
        userName: "",
        merchantName: "",
        merchantId: "",
        pageNo,
        pageSize,
      };
      this.shopPageInfo.loading = true;
      queryShopList(params).then((res) => {
        this.shopPageInfo.loading = false;
        if (res.data.error_code === 0) {
          const newList = res.data.data.list.map(v => ({
            label: v.merchantName,
            value: v.merchantId,
          }));
          this.shopList = [...this.shopList, ...newList];
          if (pageNo === 1) { // 首次请求选择列表第一项
            this.flowForm.merchantId = newList[0].value;
            this.fetchCashierList(this.flowForm.merchantId);
            this.queryData();
          }
          if (newList.length < pageSize) {
            this.shopPageInfo.finished = true;
          } else {
            this.shopPageInfo.pageNo += 1;
          }
        }
      });
      return true;
    },
    getDeviceInfo(merchantId, typeNo) {
      const params = { merchantId, typeNo };
      listAllTransToolByMerchantId(params).then((res) => {
        if (res.data.error_code === 0) {
          this.deviceNumber = res.data.data;
        }
      });
    },
    queryData() {
      Object.assign(this.flowForm, this.page);
      const param = Object.assign({}, this.flowForm);
      if (param.cashierAreaList[0] === "@") {
        param.cashierAreaList = [];
        this.cashierList.forEach((v) => {
          if (v.cashierAreaNo !== "@") {
            param.cashierAreaList.push(v.cashierAreaNo);
          }
        });
      }
      if (param.minTransAmount !== "") {
        param.minTransAmount *= 100;
      }
      if (param.maxTransAmount !== "") {
        param.maxTransAmount *= 100;
      }
      this.loadingTable = true;
      listTransDetail(param).then((res) => {
        this.loadingTable = false;
        if (res.data.error_code === 0) {
          this.tableData = res.data.data.list;
          this.page.count = res.data.data.totalCount;
        }
      });
    },
    // 查看详情
    viewFlowDetail(row, ifRefund) {
      if (ifRefund) {
        this.refundDialogViewDetial = true;
      } else {
        this.dialogViewDetial = true;
      }
      this.transDetail = row;
    },
    // 申请退款
    refundConfirm() {
      const refundPassword = this.$md5(this.refundForm.businessVerifyCode);
      const params = {
        merchantId: this.transDetail.merchantId,
        refundPassword,
        orderId: this.transDetail.leshuaOrderId,
        refundAmount: this.refundForm.refund_amount * 100,
      };
      checkBusinessVerifyCode(params).then(({ data }) => {
        if (data.error_code === 0) {
          this.refundStep = 2;
          this.refundTitle = '';
          this.refundTimeout = setTimeout(() => {
            this.refundDialogViewDetial = false;
          }, 5000);
          this.refundTimeoutNum = 5;
          this.refundInter = setInterval(() => {
            this.refundTimeoutNum--;
          }, 1000);
          this.queryShopList();
        }
      });
    },
    handleCustomSelectChange() {
      this.flowForm.transStatus = this.flowForm.transType === '1' ? '5' : '1';
    },
  },
};
</script>
<style lang="scss">
.refund-btn-grey {
  color: #666 !important;
  background-color: #ececec !important;
}

.view-refund {
  margin-left: 10px;
  color: #ff9c00 !important;
}

.refund-step-two {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;

  span {
    margin-top: 30px;
    font-size: 22px;
    color: #333;
  }

  div {
    margin-top: 20px;
    font-size: 16px;
    color: #999;
  }
}

.flow-container {
  > .header {
    position: relative;
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-from {
    padding: 40px 50px 20px;
    overflow: hidden;
    border-bottom: 20px solid #eee;

    .el-form-item.el-form-item__label {
      height: 32px;
      font-size: 14px;
      line-height: 32px;
    }

    .el-form--inline .el-form-item__label {
      font-size: 14px;
      font-weight: 400;
      color: #333;

      .el-form-item__content {
        overflow: hidden;
      }
    }

    .el-tag__close {
      font-size: 16px;
    }

    .middle-item {
      margin-right: 40px;
    }

    .trans-amount {
      margin-top: 3px;

      .el-form-item__content {
        border: 1px solid #dcdfe6;
        border-radius: 4px;
      }

      .el-input__inner {
        border: none;
      }
    }

    .save-btn-active {
      color: #666;
      background: #ececec !important;
    }

    .btn-box {
      float: right;
    }

    .line {
      display: inline-block;
      width: 10px;
      height: 2px;
      margin-right: 10px;
      vertical-align: middle;
      background: #999;
    }

    .el-select .el-select__tags {
      margin-top: 4px;
    }

    .el-select .el-select__tags > span {
      display: flex;
    }

    .middle-item .el-select .el-select__tags {
      margin-top: 0;
    }

    .el-tag.el-tag--info {
      display: flex;
      align-items: center;
      max-width: 100%;
    }
  }

  .table-content {
    overflow: hidden;
    background: #f7f7f7;

    .table-content-item {
      padding: 40px 50px;
      overflow: hidden;
      background: #fff;

      .view-detail {
        color: #1395ff;
        cursor: pointer;
      }
    }
  }

  .view-detail {
    .el-dialog {
      border-radius: 6px;
    }

    .el-dialog__header {
      padding: 40px 30px 0 40px;
    }

    .el-dialog__body {
      padding: 00 30px 0 40px;
    }

    .el-dialog__footer {
      padding-bottom: 50px;
      margin-top: 45px;
      text-align: center;

      .el-button {
        width: 120px;
        height: 38px;
        color: #fff !important;
        background: #008cff !important;
        border: none;

        &:hover,
        &:focus {
          color: #008cff !important;
          border: 1px solid #008cff !important;
        }
      }
    }

    .content {
      .one-part {
        margin-top: 35px;
        font-size: 14px;

        .item-info {
          display: flex;
          margin-top: 20px;
        }

        .title {
          width: 100px;
          color: #999;
        }

        .el-input-number {
          display: block;
        }

        .text {
          font-weight: 400;
          color: #333;
        }

        .title-input {
          line-height: 40px;

          .el-button {
            margin-left: 24px;
            color: #1395ff;
          }
        }
      }
    }
  }
}
</style>
